"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Node = void 0;
var _conditions = require("./conditions"),
  _types = require("./types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var Node = /*#__PURE__*/function () {
  function Node(a, b, c) {
    _classCallCheck(this, Node);
    if (_defineProperty(this, "nodeValue", void 0), _defineProperty(this, "nodeError", void 0), _defineProperty(this, "leftChild", void 0), _defineProperty(this, "rightChild", void 0), _defineProperty(this, "inverseResult", !1), this.isOperator(a)) this.nodeValue = a;else {
      var d;
      var _b = _conditions.ConditionFactory.createCondition(a);
      this.inverseResult = null !== (d = a.isInclude) && void 0 !== d && !d, _b.ok ? this.nodeValue = _b.data : this.nodeError = _b.error;
    }
    this.leftChild = b, this.rightChild = c;
  }
  return _createClass(Node, [{
    key: "value",
    get: function get() {
      return this.nodeValue;
    }
  }, {
    key: "error",
    get: function get() {
      return this.nodeError;
    }
  }, {
    key: "left",
    get: function get() {
      return this.leftChild;
    }
  }, {
    key: "right",
    get: function get() {
      return this.rightChild;
    }
  }, {
    key: "inverse",
    get: function get() {
      return this.inverseResult;
    }
  }, {
    key: "isOperator",
    value: function isOperator(a) {
      return a === _types.Operator.And || a === _types.Operator.Or;
    }
  }]);
}();
exports.Node = Node;